import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { advertChannelManageAdd, advertChannelManageUpd } from "@/api/financial/backhaul";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        advert_channel_name: "",
        advert_channel_mark: '',
        params: []
      },
      rules: {
        advert_channel_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        advert_channel_mark: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }] // params: [{ required: true, message: "请添加参数", trigger: "blur" }],
        // value: [{ required: true, message: "请输入参数", trigger: "blur" }],

      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  data = _objectSpread({}, row);
                  data.params = data.params ? JSON.parse(data.params).map(function (i) {
                    return {
                      value: i
                    };
                  }) : [];
                  _this.formData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.params.push({
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.params.indexOf(item);

      if (index !== -1) {
        this.formData.params.splice(index, 1);
      }
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.formData));
          var req = _this2.formData.id ? advertChannelManageUpd : advertChannelManageAdd;
          data.params = data.params.map(function (i) {
            return i.value;
          });
          req(data).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      var _this3 = this;

      this.formData = {
        id: this.formData.id,
        advert_channel_name: "",
        advert_channel_mark: '',
        params: []
      };
      this.$nextTick(function () {
        _this3.$refs.ruleForm.resetFields();
      });
    }
  }
};